module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/251-samoa-9c29126a7f33a946d213dfc425c582e6.svg";